import React, { Component } from "react";

import {
  CCard,
  CCardHeader,
  CCardBody,
  CLabel,
  CButton,
  CSelect
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Prompt } from "react-router-dom/cjs/react-router-dom.min";
import Select from "react-select";
import {
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormGroup,
  Modal,
  ModalHeader,
  Label,
  ModalBody
} from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import Breadcrumb from "../../../components/Breadcrumb";
import ContentComponent from "../../../components/Content/content";
import Loading from "../../../components/Loading";
import CreateFilterOffline from "../../../components/OfflineRegister/CreateFilterOffline";
import StudentPresenceTable from "../../../components/OfflineRegister/StudentPresenceTable";
import ProtectedRoute from "../../../components/ProtectedRoute";
import RichText from "../../../components/RichText/SlateEditor/Editor";
import URL from "../../../config/api";
import axios from "../../../config/axios";
import { getDisciplineName, getDisciplines } from "../../../utils/bncc";

class DailyRecordEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // continue: true,
      loading: false,
      creating: true,
      type: 0,
      typeName: "Todos",
      typeIcon: "",
      typeColor: "",
      types: [],
      showModal: false,
      contents: [],
      disciplineList: null,
      date: null,
      // room_id: null,
      // user_id: null,
      // teacher_id: null,
      student_list: null,
      infoSelected: null,
      ValorDescricao: null,
      description: "",
      segments: null,
      // segment: null,
      // disciplines: null,
      objectives: null,
      // abilities: null,
      // ability: null,
      disciplineDaily: null,
      // objective: null,
      arrayAbilities: []
      // descriptionRichText: null,
      // arraySegment: []
    };
  }

  componentDidMount() {
    const { id } = this.props.match.params;

    axios
      .get(`${URL.api}classification/ability/filterStructure`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({
          segments: resp.data.data,
          loading: false
        });
      });

    this.setState({ loading: true });
    this.props.setObj(16, 63, 63);
    const type = "0";
    axios
      .get(`${URL.api}content/type/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({
          types: resp.data.data,
          loading: false
          // continue: false
        });
      });

    axios
      .get(`${URL.api}classification/discipline/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        let arr = [];
        resp.data.data.forEach(item => {
          let obj = {
            value: item.id,
            label: item.name
          };
          arr.push(obj);
        });

        this.setState({
          disciplineList: arr,
          loading: false
          // continue: false
        });
      });

    axios
      .get(`${URL.api}daily/singleView/${id}`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        const respData = resp.data;
        if (resp.data.data.text) {
          let text = JSON.parse(resp.data.data.text);
          this.setState({ ValorDescricao: text });
        }

        this.getInfoSelectors(
          respData.group_id,
          respData.region_id,
          respData.school_id,
          respData.room_id,
          respData.teacher_id
        );

        this.setState(
          {
            arrayAbilities: resp.data.data.abilities,
            description: resp.data.data.text,
            disciplineDaily: {
              value: resp.data.data.discipline_id,
              label: resp.data.data.discipline_name
            },
            date: resp.data.data.date
          },
          () => {
            this.state.arrayAbilities.map((item, index) => {
              this.updateSegment(index);
            });
          }
        );

        let newUsers = [];
        resp.data.data.users.map(item => {
          let obj = {
            id: item.student_id,
            nome: item.student_name,
            status: item.accessed === true ? "Presente" : "Ausente"
          };
          newUsers.push(obj);
        });
        let newData = resp.data.data;
        newData.users = newUsers;
        this.setState({ data: newData, student_list: newData });
      });
  }

  changeDisciplineSelectedOnDaily = e => {
    this.setState({ disciplineDaily: e });
  };

  updatechangeDisciplineSelected(index) {
    // eslint-disable-next-line react/no-access-state-in-setstate
    const prev = [...this.state.arrayAbilities];

    const objectives =
      prev[index].disciplines.find(item => item.id === prev[index].discipline)
        ?.objectives || [];
    prev[index].objectives = objectives;

    this.setState({ arrayAbilities: prev }, () => {
      // eslint-disable-next-line react/no-access-state-in-setstate
      const prev = [...this.state.arrayAbilities];

      const abilities = prev[index].objectives
        .map(objective => ({
          label: objective.description,
          id: objective.id,
          options: objective.abilities.map(ability => ({
            label: `(${ability.code}) ${ability.description}`,
            value: ability.id,
            objective: objective.id
          }))
        }))
        .filter(objective => objective.options.length > 0);

      prev[index].abilities = abilities;
      this.setState({ arrayAbilities: prev }, () => {
        // eslint-disable-next-line react/no-access-state-in-setstate
        const prev = [...this.state.arrayAbilities];
        prev[index].ability = {
          value: prev[index].ability_id,
          label: prev[index].ability_description
        };
        this.setState({ arrayAbilities: prev });
      });
    });
  }

  changeDisciplineSelected = (e, index) => {
    // eslint-disable-next-line react/no-access-state-in-setstate
    const prev = [...this.state.arrayAbilities];
    prev[index].discipline = Number(e.target.value);
    prev[index].ability = null;

    this.setState({ arrayAbilities: prev }, () => {
      // eslint-disable-next-line react/no-access-state-in-setstate
      const prev = [...this.state.arrayAbilities];

      const objectives =
        prev[index].disciplines.find(item => item.id === prev[index].discipline)
          ?.objectives || [];
      prev[index].objectives = objectives;

      this.setState({ arrayAbilities: prev }, () => {
        // eslint-disable-next-line react/no-access-state-in-setstate
        const prev = [...this.state.arrayAbilities];

        const abilities = prev[index].objectives
          .map(objective => ({
            label: objective.description,
            id: objective.id,
            options: objective.abilities.map(ability => ({
              label: `(${ability.code}) ${ability.description}`,
              value: ability.id,
              objective: objective.id
            }))
          }))
          .filter(objective => objective.options.length > 0);

        prev[index].abilities = abilities;
        this.setState({ arrayAbilities: prev });
      });
    });
  };

  updateSegment(index) {
    axios
      .get(`${URL.api}classification/ability/filterStructure`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState(
          {
            segments: resp.data.data,
            loading: false
          },
          () => {
            // eslint-disable-next-line react/no-access-state-in-setstate
            const prev = [...this.state.arrayAbilities];
            const disciplines =
              this.state.segments.find(item => item.id === prev[index].segment)
                ?.disciplines || [];
            prev[index].disciplines = disciplines;
            this.setState({ arrayAbilities: prev }, () => {
              this.updatechangeDisciplineSelected(index);
            });
          }
        );
      });
  }

  changeSegment(e, index) {
    // eslint-disable-next-line react/no-access-state-in-setstate
    const prev = [...this.state.arrayAbilities];
    prev[index].segment = parseInt(e.target.value);
    prev[index].ability = null;
    prev[index].discipline = 0;

    this.setState({ arrayAbilities: prev }, () => {
      // eslint-disable-next-line react/no-access-state-in-setstate
      const prev = [...this.state.arrayAbilities];
      const disciplines =
        this.state.segments.find(item => item.id === prev[index].segment)
          ?.disciplines || [];

      prev[index].disciplines = disciplines;
      this.setState({ arrayAbilities: prev });
    });
  }

  abilityChanger(e, index) {
    // eslint-disable-next-line react/no-access-state-in-setstate
    const prev = [...this.state.arrayAbilities];
    prev[index].ability = e;

    this.setState({ arrayAbilities: prev });
  }

  updateAbilityAndAbilities() {
    const abilities = this.state.objectives
      .map(objective => ({
        label: objective.description,
        id: objective.id,
        options: objective.abilities.map(ability => ({
          label: `(${ability.code}) ${ability.description}`,
          value: ability.id,
          objective: objective.id
        }))
      }))
      .filter(objective => objective.options.length > 0);

    let ability = abilities
      .reduce((acc, val) => [...acc, ...val.options], [])
      .find(ability => ability.value === this.props.ability);

    // this.setState({ abilities, ability });
  }

  addAbility() {
    this.setState(state => {
      const prev = [...state.arrayAbilities];
      prev.push({
        segment: null,
        discipline: null,
        ability: null,
        disciplines: null,
        objectives: null
      });
      return { arrayAbilities: prev };
    });
  }

  removeAbility(index) {
    this.setState(state => {
      let prev = [...state.arrayAbilities];
      prev.splice(index, 1);

      let { principal } = state;

      if (principal === index) {
        principal = null;
      } else if (principal > index) {
        principal -= 1;
      }

      return { arrayAbilities: prev, principal };
    });
  }

  getStudentList = studentList => {
    this.setState({ student_list: studentList });
  };

  removeContent = contentId => {
    // eslint-disable-next-line react/no-access-state-in-setstate
    let contentList = [...this.state.contents];
    let position;
    contentList.forEach((item, index) => {
      if (item.contentId === contentId) {
        position = index;
      }
    });
    contentList.splice(position, 1);
    this.setState({ contents: contentList });
  };

  addContent = (contentName, contentId) => {
    // eslint-disable-next-line react/no-access-state-in-setstate
    const contentList = [...this.state.contents];
    let obj = {
      contentName,
      contentId
    };
    contentList.push(obj);
    this.setState({ contents: contentList });
  };

  hideModal = hide => {
    this.setState({ showModal: !hide });
  };

  getDate = date => {
    let myDate = `${date}`;
    myDate = myDate.replaceAll("-", ".");
    let newDate = new Date(Math.floor(new Date(myDate).getTime()));
    this.setState({ date: newDate });
  };

  getInfoSelectors = (groupId, regionId, schoolId, roomId, teacherId) => {
    let obj = {
      groupId,
      regionId,
      schoolId,
      roomId,
      teacherId
    };
    this.setState({ infoSelected: obj });
  };

  setValorDescrição(val) {
    this.setState({
      ValorDescricao: val
    });
  }

  changeDescription = e => {
    let { value } = e.target;
    this.setState({
      description: value
    });
  };

  getText() {
    return this.state.ValorDescricao;
  }

  // register
  editRegister() {
    this.setState({ creating: false });
    const { id } = this.props.match.params;
    let check = true;
    let studentList = [];

    if (this.state.infoSelected.roomId === 0) {
      toastr.error("Erro", "Campo turma está vazio");
      check = false;
    }

    if (this.state.date === null) {
      toastr.error("Erro", "Campo data está vazio");
      check = false;
    }

    if (this.state.student_list === null) {
      toastr.error("Erro", "Campo de usuários está vazio");
      check = false;
    }

    if (this.state.disciplineDaily.value === 0) {
      toastr.error("Erro", "Campo disciplina está vazio");
      check = false;
    }

    if (check) {
      this.state.student_list.forEach(item => {
        let obj = {
          student_id: item.id,
          accessed: item.status === "Presente"
        };
        studentList.push(obj);
      });

      let arrayAbilities = [];
      this.state.arrayAbilities.forEach(item => {
        if (item.ability_id) {
          arrayAbilities.push(item.ability_id);
        } else {
          arrayAbilities.push(item.ability.value);
        }
      });

      let text = JSON.stringify(this.getText());

      let obj = {
        user_id: this.props.user.user.id,
        room_id: this.state.infoSelected.roomId,
        discipline_id: this.state.disciplineDaily.value,
        date: this.state.date,
        users: studentList,
        teacher_id: this.state.infoSelected.teacherId,
        abilities: arrayAbilities.length > 0 ? arrayAbilities : [],
        text
      };

      axios
        .post(`${URL.api}daily/update/${id}`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(() => {
          this.props.history.push("/daily/list");
        });
    }
  }

  disableFields = () => {};

  render() {
    const query = new URLSearchParams(this.props.location.search);
    const serie = query.get("serie") || null;
    const discipline = query.get("discipline") || null;

    return (
      <div className="d-flex flex-column align-items-left">
        <Prompt
          when={this.state.creating}
          message="Os dados do formulário ainda não foram salvos. Tem certeza de que deseja sair desta página?"
        />
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/daily/list", to: "/daily/list" }]}
        />
        <CCard>
          <CCardHeader className="d-flex align-items-center">
            <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
              <h4 className="card-title mb-1">Editar Registro Diário</h4>
              <div className="small text-muted">Edite um Registro Diário</div>
            </div>
            <div>
              <CButton
                color="primary"
                className="ml-2"
                onClick={() => this.editRegister(false)}
              >
                <i className="fa fa-cloud-upload mr-2"></i>
                Salvar
              </CButton>
            </div>
          </CCardHeader>
          <CCardBody>
            {this.state.data && (
              <CreateFilterOffline
                user={this.props.user}
                getDate={this.getDate}
                getInfoSelectors={this.getInfoSelectors}
                infoView={this.state.data}
                editOfflineRegister
                isEditMode
              />
            )}
            <div className="myRow">
              <div className="flex-1 mb-2">
                <div className="w-100 text-ellipsis">
                  <Label className="d-block w-100 text-ellipsis">
                    Disciplina
                  </Label>
                </div>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="fa fa-text-width"></i>
                    </InputGroupText>
                  </InputGroupAddon>
                  <Select
                    placeholder="Selecione a Disciplina"
                    onChange={e => this.changeDisciplineSelectedOnDaily(e)}
                    value={this.state.disciplineDaily}
                    options={this.state.disciplineList}
                    type="text"
                    className="flex-1"
                  />
                </InputGroup>
              </div>
              <Label className="d-block w-100 text-ellipsis">Habilidade</Label>
              {this.state.arrayAbilities &&
                this.state.arrayAbilities.map(
                  (item, index) =>
                    this.state.segments && (
                      <FormGroup className="mb3 mt-3" key={index}>
                        <div className="d-flex w-100 mt-2">
                          <div className="mx-2 flex-1">
                            <span className="mr-2">Segmento:</span>
                            <CSelect
                              placeholder="Segmento"
                              value={item.segment}
                              onChange={e => this.changeSegment(e, index)}
                              disabled={false}
                            >
                              <option value={0}>Segmento</option>
                              {this.state.segments.map(segment => (
                                <option key={segment.id} value={segment.id}>
                                  {segment.name}
                                </option>
                              ))}
                            </CSelect>
                          </div>
                          {item.segment && item.disciplines && (
                            <div className="mx-2 flex-1">
                              <span className="mr-2">Disciplina:</span>
                              <CSelect
                                placeholder={getDisciplineName(item.segment)}
                                value={item.discipline}
                                onChange={e =>
                                  this.changeDisciplineSelected(e, index)
                                }
                                disabled={false}
                              >
                                <option value={null}>
                                  {getDisciplineName(item.segment)}
                                </option>
                                {getDisciplines(
                                  item.segment,
                                  item.disciplines
                                ).map(discipline => (
                                  <option
                                    key={discipline.id}
                                    value={discipline.id}
                                  >
                                    {discipline.name}
                                  </option>
                                ))}
                              </CSelect>
                            </div>
                          )}
                          {item.abilities && (
                            <div className="mx-2 flex-1">
                              <span className="mr-2">Habilidade:</span>
                              <Select
                                placeholder="Selecione a Habilidade"
                                name="Habilidade"
                                options={item.abilities}
                                value={item.ability}
                                className="basic-multi-select flex-1"
                                classNamePrefix="select"
                                noOptionsMessage={() =>
                                  "Selecione um Segmento e um Componente curricular"
                                }
                                disabled={false}
                                readOnly={false}
                                onChange={e => this.abilityChanger(e, index)}
                              />
                            </div>
                          )}
                          <CButton
                            variant="outline"
                            color="secondary"
                            className="ml-3 text-dark mt-3"
                            onClick={() => this.removeAbility(index)}
                          >
                            <i className="fa fa-trash"></i>
                          </CButton>
                        </div>
                      </FormGroup>
                    )
                )}
              <CButton
                variant="outline"
                color="secondary"
                className="mt-2 text-dark"
                onClick={() => this.addAbility()}
              >
                Adicionar uma Habilidade
              </CButton>
              <FormGroup className="mb3 mt-3">
                <CLabel>Descrição</CLabel>
                <InputGroup>
                  {this.state.description && (
                    <RichText
                      setValorDescricao={val =>
                        this.setState({ ValorDescricao: val })
                      }
                      description={this.state.description}
                      // eslint-disable-next-line react/jsx-boolean-value
                      editavel={true}
                    />
                  )}
                </InputGroup>
              </FormGroup>
              <Modal
                isOpen={this.state.showModal}
                toggle={null}
                className={null}
                onOpened={() => this.componentDidMount()}
                size="lg"
              >
                <ModalHeader className="d-flex justify-content-end">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      this.setState({ showModal: false });
                    }}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </ModalHeader>
                {this.state.loading ? (
                  <div className="p-4">
                    <Loading />
                  </div>
                ) : (
                  <ContentComponent
                    type={this.state.type}
                    typeName={this.state.typeName}
                    typeIcon={this.state.typeIcon}
                    typeColor={this.state.typeColor}
                    types={this.state.types}
                    currentRoute={this.props.currentRoute}
                    serie={serie}
                    discipline={discipline}
                    isOfflineRegister
                    addContent={this.addContent}
                    hideModal={this.hideModal}
                    disciplineSelected={this.state.disciplineDaily}
                  />
                )}
              </Modal>
              <CLabel className="mt-2">Lista de Presença</CLabel>
              {this.state.data && (
                <StudentPresenceTable
                  getStudentList={this.getStudentList}
                  roomId={
                    this.state.infoSelected ? this.state.infoSelected : null
                  }
                  editOfflineRegister
                  infoView={this.state.data}
                  isEditMode
                />
              )}
            </div>
          </CCardBody>
          <ProtectedRoute routeId={this.props.currentRoute} />
        </CCard>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(DailyRecordEdit);
